<kilowant-header [isHome]="true" title="About" linkHome="/"></kilowant-header>
<div class="wrapper-main-public-area home-page">
    <div class="home-inner">
        <div class="f18 mt-20">James M. Grasso, Founder</div>
        <div class="f13 mb-20">jgrasso&#64;kilowant.com</div>
        <div class="about-photo"></div>
        <div class="about-text"></div>
        <p class="mt-20">James is a 30 year veteran of the retail energy industry with an established reputation as a market expert and consumer advocate.</p>
        <p class="mt-20">Prior to founding kilowant in 2022 he founded <a href="https://www.silentsherpa.com/">SilentSherpa</a> in 2000, a leader in energy market guidance services and solutions for commercial and institutional consumers.</p>
    </div>
</div>